import React from "react";
import CardAllcategories0 from "./cardAllcategories0";
import CategoryShowcaseGrid from "./categoryShowcase";
import { getMatrixChildren } from "./CategoryMatrixPreview";

const CardAllcategories = (props) => {
  const {
    laguangeElakay,
    infoSource,
    ButtonViewCategories,
    setLevel,
    level,
    divSubCategories,
    // Matrix Mode: previews `parents` map + the parent of the top-level cards.
    matrixParents,
    rootCategoryId,
  } = props;
  const rootMatrixChildren = getMatrixChildren(matrixParents, rootCategoryId);

  return (
    <div className="ec-allcat-expanded">
      <CategoryShowcaseGrid
        items={level.level_0.ar1}
        ar={level.level_0.ar}
        infoSource={infoSource}
        ButtonViewCategories={ButtonViewCategories}
        activeId={level.id}
        matrixChildren={rootMatrixChildren}
      />

      {level.level_1 && (
        <div ref={divSubCategories} className="ec-allcat-detail">
          <CardAllcategories0
            laguangeElakay={laguangeElakay}
            infoSource={infoSource}
            setLevel={setLevel}
            level={level}
            matrixParents={matrixParents}
          />
        </div>
      )}

      <CategoryShowcaseGrid
        items={level.level_0.ar2}
        ar={level.level_0.ar}
        infoSource={infoSource}
        ButtonViewCategories={ButtonViewCategories}
        activeId={level.id}
        matrixChildren={rootMatrixChildren}
      />
    </div>
  );
};

export default CardAllcategories;
